import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

const BackdropLoader = ({ open, handleClose }: any) => {
	return (
		<div>
			<Backdrop
				// eslint-disable-next-line arrow-parens
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={open}
				onClick={handleClose}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</div>
	);
};

export default BackdropLoader;
